import { formatDateObjectToString, formatDateStringToObject } from 'syf-js-utilities/formats';
/**
 * Returns a the timestamp delta between 12:00 today and now
 */
const getTodaysTimeOffset = () => {
    const today = formatDateStringToObject(formatDateObjectToString(new Date()));
    return Date.now() - today.getTime();
};
export default getTodaysTimeOffset;
